import React, { useState } from 'react';
import { SmartphoneIcon, ShieldIcon, DropletsIcon, ZapIcon, HomeIcon, LandmarkIcon, GraduationCapIcon, HeartPulseIcon, PlaneIcon, MoreHorizontalIcon, CalendarClockIcon, ClockIcon, BookmarkIcon, SearchIcon, ChevronDownIcon, ChevronRightIcon, AlertCircleIcon } from 'lucide-react';
import { StatusBar } from './StatusBar';
import { ScreenHeader } from './ScreenHeader';
const CATEGORIES = [{
  id: 'telecom',
  label: 'Telecom',
  icon: SmartphoneIcon,
  color: 'from-blue-500 to-cyan-400'
}, {
  id: 'water',
  label: 'Water',
  icon: DropletsIcon,
  color: 'from-cyan-500 to-teal-400'
}, {
  id: 'electricity',
  label: 'Electricity',
  icon: ZapIcon,
  color: 'from-amber-500 to-orange-400'
}, {
  id: 'insurance',
  label: 'Insurance',
  icon: ShieldIcon,
  color: 'from-indigo-500 to-purple-400'
}, {
  id: 'finance',
  label: 'Finance',
  icon: LandmarkIcon,
  color: 'from-emerald-500 to-green-400'
}, {
  id: 'education',
  label: 'Education',
  icon: GraduationCapIcon,
  color: 'from-rose-500 to-pink-400'
}, {
  id: 'hospital',
  label: 'Hospital',
  icon: HeartPulseIcon,
  color: 'from-red-500 to-rose-400'
}, {
  id: 'rental',
  label: 'Home Rental',
  icon: HomeIcon,
  color: 'from-slate-500 to-gray-400'
}, {
  id: 'travel',
  label: 'Travel',
  icon: PlaneIcon,
  color: 'from-sky-500 to-blue-400'
}, {
  id: 'other',
  label: 'Other',
  icon: MoreHorizontalIcon,
  color: 'from-gray-400 to-gray-300'
}];
const POPULAR_BILLERS = [{
  id: 'slt',
  name: 'Sri Lanka Telecom',
  type: 'Telecommunications',
  initials: 'SLT',
  color: '#009AC7'
}, {
  id: 'ceb',
  name: 'Ceylon Electricity Board',
  type: 'Electricity',
  initials: 'CEB',
  color: '#F59E0B'
}, {
  id: 'waterboard',
  name: 'National Water Supply',
  type: 'Water',
  initials: 'NWS',
  color: '#06B6D4'
}, {
  id: 'slic',
  name: 'Sri Lanka Insurance',
  type: 'Insurance',
  initials: 'SLI',
  color: '#8B5CF6'
}, {
  id: 'dialog',
  name: 'Dialog Axiata',
  type: 'Telecommunications',
  initials: 'DA',
  color: '#EF4444'
}, {
  id: 'singer',
  name: 'Singer Sri Lanka',
  type: 'Finance / Retail',
  initials: 'SIN',
  color: '#DC2626'
}, {
  id: 'abans',
  name: 'Abans',
  type: 'Finance / Retail',
  initials: 'AB',
  color: '#EA580C'
}, {
  id: 'sinhagiri',
  name: 'Sinhagiri',
  type: 'Finance / Retail',
  initials: 'SG',
  color: '#16A34A'
}, {
  id: 'srilankan',
  name: 'SriLankan Airlines',
  type: 'Airlines',
  initials: 'SLA',
  color: '#0284C7'
}];
const RECENT_BILLS = [{
  id: 'rb1',
  name: 'CEB · Electricity',
  date: 'Paid 24 May',
  amount: 'LKR 4,820',
  color: '#F59E0B',
  initials: 'CEB'
}, {
  id: 'rb2',
  name: 'Dialog · Mobile',
  date: 'Paid 18 May',
  amount: 'LKR 1,990',
  color: '#EF4444',
  initials: 'DA'
}, {
  id: 'rb3',
  name: 'NWS · Water',
  date: 'Paid 12 May',
  amount: 'LKR 1,250',
  color: '#06B6D4',
  initials: 'NWS'
}];
export function BillsScreen({
  onBack
}: {
  onBack: () => void;
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const filteredBillers = POPULAR_BILLERS.filter(biller => biller.name.toLowerCase().includes(searchQuery.toLowerCase()) || biller.type.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="relative flex flex-col w-full h-full overflow-hidden" style={{
    backgroundColor: '#F4F7FA'
  }} data-id="element-53">
      <StatusBar data-id="element-54" />
      <ScreenHeader title="Pay Bills" onBack={onBack} data-id="element-55" />

      <div className="flex-1 overflow-y-auto pb-6" data-id="element-56">
        {/* Due-soon alert — banker priority surface */}
        <div className="px-5 pt-1 pb-4" data-id="element-57">
          <div className="relative overflow-hidden rounded-2xl p-3.5" style={{
          background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)',
          border: '1px solid #FCD34D'
        }} data-id="element-58">
            <div className="flex items-center gap-3" data-id="element-59">
              <span className="shrink-0 flex items-center justify-center rounded-xl" style={{
              width: 40,
              height: 40,
              backgroundColor: '#F59E0B',
              color: '#FFFFFF'
            }} data-id="element-60">
                <AlertCircleIcon size={20} strokeWidth={2.5} data-id="element-61" />
              </span>
              <div className="flex-1 min-w-0" data-id="element-62">
                <div style={{
                fontSize: 11,
                fontWeight: 700,
                color: '#92400E',
                letterSpacing: '0.06em'
              }} data-id="element-63">
                  DUE IN 2 DAYS
                </div>
                <div className="mt-0.5" style={{
                fontSize: 13.5,
                fontWeight: 700,
                color: '#1A1A1A'
              }} data-id="element-64">
                  CEB · Electricity Bill
                </div>
                <div className="mt-0.5" style={{
                fontSize: 12,
                fontWeight: 600,
                color: '#92400E'
              }} data-id="element-65">
                  LKR 4,820.00
                </div>
              </div>
              <button type="button" className="shrink-0 rounded-full text-white transition-all active:scale-[0.97]" style={{
              backgroundColor: '#92400E',
              padding: '8px 14px',
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: '0.01em'
            }} data-id="element-66">
                Pay now
              </button>
            </div>
          </div>
        </div>

        {/* Pay From */}
        <div className="px-5 pb-4" data-id="element-67">
          <SectionLabel data-id="element-68">Pay from</SectionLabel>
          <button type="button" className="w-full flex items-center justify-between px-4 py-3.5 rounded-2xl bg-white transition-all active:scale-[0.99]" style={{
          border: '1px solid #E5EAF0',
          boxShadow: '0 1px 2px rgba(15,23,42,0.03)'
        }} data-id="element-69">
            <div className="flex items-center gap-3" data-id="element-70">
              <div className="flex items-center justify-center rounded-xl" style={{
              width: 40,
              height: 40,
              backgroundColor: '#E6F7FB',
              color: '#009AC7'
            }} data-id="element-71">
                <LandmarkIcon size={20} data-id="element-72" />
              </div>
              <div className="text-left" data-id="element-73">
                <div style={{
                fontSize: 14,
                fontWeight: 700,
                color: '#1A1A1A'
              }} data-id="element-74">
                  Savings Account
                </div>
                <div className="mt-0.5" style={{
                fontSize: 12,
                fontWeight: 500,
                color: '#64748B'
              }} data-id="element-75">
                  0123 •••• 8910
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-76">
              <div className="text-right" data-id="element-77">
                <div style={{
                fontSize: 14,
                fontWeight: 800,
                color: '#1A1A1A'
              }} data-id="element-78">
                  LKR 482,650
                </div>
                <div className="mt-0.5" style={{
                fontSize: 11,
                fontWeight: 600,
                color: '#10B981'
              }} data-id="element-79">
                  Available
                </div>
              </div>
              <ChevronDownIcon size={18} style={{
              color: '#94A3B8'
            }} data-id="element-80" />
            </div>
          </button>
        </div>

        {/* Search Biller */}
        <div className="px-5 mb-5" data-id="element-81">
          <SectionLabel data-id="element-82">Search biller</SectionLabel>
          <div className="relative" data-id="element-83">
            <button type="button" onClick={() => setDropdownOpen(o => !o)} className="w-full flex items-center gap-2.5 px-4 rounded-2xl bg-white transition-all" style={{
            minHeight: 52,
            border: dropdownOpen ? '1.5px solid #009AC7' : '1.5px solid #E5EAF0',
            boxShadow: dropdownOpen ? '0 0 0 4px rgba(0,154,199,0.12)' : 'none'
          }} data-id="element-84">
              <SearchIcon size={18} color={dropdownOpen ? '#009AC7' : '#94A3B8'} data-id="element-85" />
              <input type="text" value={searchQuery} onChange={e => {
              setSearchQuery(e.target.value);
              setDropdownOpen(true);
            }} onFocus={() => setDropdownOpen(true)} placeholder="Tap to search billers, companies..." className="flex-1 bg-transparent outline-none" style={{
              fontSize: 14,
              fontWeight: 500,
              color: '#1A1A1A'
            }} data-id="element-86" />
              <ChevronDownIcon size={18} color="#94A3B8" style={{
              transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 200ms ease'
            }} data-id="element-87" />
            </button>
            {dropdownOpen && <div className="absolute left-0 right-0 mt-2 rounded-2xl bg-white overflow-hidden z-20" style={{
            border: '1px solid #E5EAF0',
            boxShadow: '0 12px 32px -8px rgba(15, 23, 42, 0.18), 0 2px 4px rgba(15, 23, 42, 0.04)',
            maxHeight: 320
          }} data-id="element-88">
                <div className="flex flex-col overflow-y-auto" style={{
              maxHeight: 320
            }} data-id="element-89">
                  {filteredBillers.length === 0 ? <div className="text-center py-6" style={{
                fontSize: 13,
                color: '#64748B',
                fontWeight: 500
              }} data-id="element-90">
                      No billers found matching "{searchQuery}"
                    </div> : filteredBillers.map((biller, idx) => <button key={biller.id} type="button" onClick={() => {
                setSearchQuery(biller.name);
                setDropdownOpen(false);
              }} className="flex items-center gap-3 px-4 py-2.5 bg-white transition-colors active:bg-neutral-50 hover:bg-neutral-50 text-left" style={{
                borderBottom: idx === filteredBillers.length - 1 ? 'none' : '1px solid #F1F5F9'
              }} data-id="element-91">
                        <div className="flex items-center justify-center rounded-xl shrink-0" style={{
                  width: 38,
                  height: 38,
                  backgroundColor: `${biller.color}15`,
                  color: biller.color
                }} data-id="element-92">
                          <span style={{
                    fontSize: 12.5,
                    fontWeight: 800,
                    letterSpacing: '0.04em'
                  }} data-id="element-93">
                            {biller.initials}
                          </span>
                        </div>
                        <div className="flex-1 min-w-0" data-id="element-94">
                          <div className="truncate" style={{
                    fontSize: 13.5,
                    fontWeight: 700,
                    color: '#1A1A1A'
                  }} data-id="element-95">
                            {biller.name}
                          </div>
                          <div className="mt-0.5 truncate" style={{
                    fontSize: 11.5,
                    fontWeight: 500,
                    color: '#64748B'
                  }} data-id="element-96">
                            {biller.type}
                          </div>
                        </div>
                      </button>)}
                </div>
              </div>}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="px-5 mb-5" data-id="element-97">
          <div className="grid grid-cols-3 gap-3" data-id="element-98">
            <QuickAction icon={<CalendarClockIcon size={20} data-id="element-100" />} label="Schedule" tint="#009AC7" data-id="element-99" />
            <QuickAction icon={<ClockIcon size={20} data-id="element-102" />} label="Upcoming" tint="#8B5CF6" data-id="element-101" />
            <QuickAction icon={<BookmarkIcon size={20} data-id="element-104" />} label="Saved" tint="#F59E0B" data-id="element-103" />
          </div>
        </div>

        {/* Bill Categories */}
        <div className="px-5 mb-5" data-id="element-105">
          <SectionLabel data-id="element-106">Bill categories</SectionLabel>
          <div className="grid grid-cols-4 gap-3" data-id="element-107">
            {CATEGORIES.map(cat => <button key={cat.id} className="flex flex-col items-center gap-2 transition-all active:scale-[0.95]" data-id="element-108">
                <div className={`flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br ${cat.color}`} style={{
              boxShadow: '0 6px 14px -8px rgba(15,23,42,0.35)'
            }} data-id="element-109">
                  <cat.icon size={24} color="#FFFFFF" strokeWidth={2.25} data-id="element-110" />
                </div>
                <span className="text-center leading-tight" style={{
              fontSize: 11,
              fontWeight: 700,
              color: '#475569'
            }} data-id="element-111">
                  {cat.label}
                </span>
              </button>)}
          </div>
        </div>

        {/* Recent bills */}
        <div className="px-5" data-id="element-112">
          <div className="flex items-center justify-between mb-2.5 px-0.5" data-id="element-113">
            <span style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#1A1A1A'
          }} data-id="element-114">
              Recent payments
            </span>
            <button type="button" style={{
            fontSize: 11.5,
            fontWeight: 700,
            color: '#009AC7'
          }} data-id="element-115">
              See all
            </button>
          </div>
          <div className="rounded-2xl bg-white overflow-hidden" style={{
          border: '1px solid #E5EAF0'
        }} data-id="element-116">
            {RECENT_BILLS.map((b, i) => <button key={b.id} type="button" className="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors active:bg-neutral-50" style={{
            borderBottom: i === RECENT_BILLS.length - 1 ? 'none' : '1px solid #F1F5F9'
          }} data-id="element-117">
                <span className="shrink-0 flex items-center justify-center rounded-xl" style={{
              width: 38,
              height: 38,
              backgroundColor: `${b.color}18`,
              color: b.color,
              fontSize: 12,
              fontWeight: 800,
              letterSpacing: '0.02em'
            }} data-id="element-118">
                  {b.initials}
                </span>
                <div className="flex-1 min-w-0" data-id="element-119">
                  <div className="truncate" style={{
                fontSize: 13.5,
                fontWeight: 700,
                color: '#1A1A1A'
              }} data-id="element-120">
                    {b.name}
                  </div>
                  <div className="mt-0.5 truncate" style={{
                fontSize: 11.5,
                fontWeight: 500,
                color: '#64748B'
              }} data-id="element-121">
                    {b.date}
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-122">
                  <div style={{
                fontSize: 13,
                fontWeight: 700,
                color: '#1A1A1A'
              }} data-id="element-123">
                    {b.amount}
                  </div>
                  <div className="mt-0.5 inline-flex items-center gap-0.5" style={{
                fontSize: 11,
                fontWeight: 700,
                color: '#009AC7'
              }} data-id="element-124">
                    Repeat
                    <ChevronRightIcon size={12} data-id="element-125" />
                  </div>
                </div>
              </button>)}
          </div>
        </div>
      </div>

      <div className="flex justify-center pb-2" style={{
      backgroundColor: '#F4F7FA'
    }} data-id="element-126">
        <div className="w-[120px] h-[5px] rounded-full bg-neutral-900/80" aria-hidden="true" data-id="element-127" />
      </div>
    </div>;
}
function SectionLabel({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="mb-2 px-0.5" style={{
    fontSize: 12.5,
    fontWeight: 700,
    color: '#1A1A1A',
    letterSpacing: '0.01em'
  }} data-id="element-128">
      {children}
    </div>;
}
function QuickAction({
  icon,
  label,
  tint
}: {
  icon: React.ReactNode;
  label: string;
  tint: string;
}) {
  return <button type="button" className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-white transition-all active:scale-[0.96]" style={{
    minHeight: 80,
    border: '1px solid #EEF1F5',
    boxShadow: '0 1px 2px rgba(15,23,42,0.03)'
  }} data-id="element-129">
      <div className="flex items-center justify-center rounded-full" style={{
      width: 38,
      height: 38,
      backgroundColor: `${tint}18`,
      color: tint
    }} data-id="element-130">
        {icon}
      </div>
      <span style={{
      fontSize: 11.5,
      fontWeight: 700,
      color: '#1A1A1A'
    }} data-id="element-131">
        {label}
      </span>
    </button>;
}